import _ from 'lodash'
import * as React from 'react'
import * as service from '../../services'
import { TREE } from '../../config/routeType'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Select, FormControl, InputLabel, Box, MenuItem } from '@mui/material'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import * as rdx from '../../redux/slices/Search/input'
import { FilterAlt, ManageSearch } from '@mui/icons-material'
import SearchMain from './SearchMain'
import Botton from '../BottonCustom'
import {
  setSearchByType,
  setSelectedList,
  setFilterState,
  setFiltersUsed,
  setTypeSearchUsed,
  filterListInitial,
  setAdvancedSearch,
  setAdvancedSearchUsed,
} from '../../redux/slices/Search/input'

const COLOR_POPUP = 'var(--color-primary)'
const COLOR_WHITE = '#fffafa'
const WIDTHF1 = 200

const styleDefault = {
  color: COLOR_POPUP,
  border: `1px solid ${COLOR_POPUP}`,
  width: 'auto',
  fontSize: '12px',
  '&:hover': { backgroundColor: COLOR_POPUP, color: COLOR_WHITE },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
}
const styleAdvancedSearchButton = {
  color: 'grey',
  textTransform: 'none',
  width: 'auto',
  fontSize: '12px',
  '&:hover': { color: COLOR_POPUP },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
}

const SimpleSearch = ({ open, advancedSearch, basicList, windowWidth }) => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const [enableFilterButton, setEnableFilterButton] = React.useState(false)
  const [initialize, setInitialize] = React.useState(false)
  const { filter } = useSelector(state => state.filterSearch)
  const { value: isOpenDrawerRight } = useSelector(state => state.drawerRight)
  const WINDOWWIDTH = windowWidth < 600
  const wWSmall = windowWidth < 370

  const handleChangeOptions = e => {
    dispatch(setSelectedList([]))
    dispatch(setSearchByType(e.target.value))
  }

  const handleFilters = () => {
    if (isOpenDrawerRight) {
      dispatch(show(false))
      dispatch(codeTree(null))
      navigate(`/${TREE}`)
    }
    service
      .getAllDataByTreesFilters(basicList.type, basicList.filterList1)
      .then(geojson => {
        if (!Object.keys(geojson).length) {
          window.alert(
            'Oops! No se encuentraron registros, intente nuevamente o recarge la página. :)'
          )
        } else {
          dispatch(setFeature(geojson))
          dispatch(setFilterState(true))
          dispatch(setFiltersUsed(basicList.filterList1))
          dispatch(setTypeSearchUsed(basicList.type))
          dispatch(setAdvancedSearchUsed(advancedSearch))
          dispatch(filterListInitial())
          dispatch(rdx.setEnabledFilter(true))
        }
      })
      .catch(err => console.log('Error :>> ', err))
  }

  const handleAdvancedSearch = () => {
    dispatch(setAdvancedSearch(true))
  }

  React.useEffect(() => {
    if (!filter) return
    const enableBtt = Boolean(basicList.filterList1.length)
    setEnableFilterButton(enableBtt)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  React.useEffect(() => {
    if (!Boolean(basicList.filterList1.length)) return
    setEnableFilterButton(_.isEqual(basicList.filterList1, basicList.usedFilter1))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicList.filterList1])

  React.useEffect(() => {
    if (!open) return
    setEnableFilterButton(true)
    if (advancedSearch) return
    if (!_.isEqual(basicList.type, basicList.usedType))
      dispatch(setSearchByType(basicList.usedType))
    if (!_.isEqual(basicList.filterList1, basicList.usedFilter1))
      dispatch(setSelectedList(basicList.usedFilter1))
    setInitialize(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <>
      <Box
        sx={{
          pb: 1,
          width: '100%',
          maxWidth: 'calc(100vw - 95px)',
          display: 'flex',
          flexDirection: WINDOWWIDTH ? 'column' : 'row',
        }}>
        <FormControl
          size="small"
          sx={{
            width: !Boolean(basicList.type) ? '100%' : WINDOWWIDTH ? '100%' : WIDTHF1,
            pb: Boolean(basicList.type) && WINDOWWIDTH ? 1 : 0,
            pr: Boolean(basicList.type) && !WINDOWWIDTH ? 1 : 0,
          }}>
          <InputLabel id="simple-search-label">Búsqueda básica</InputLabel>
          <Select
            labelId="simple-search-label"
            id="select-simple"
            value={basicList.type}
            name="selectSimpleBox"
            label="Búsqueda básica"
            onChange={handleChangeOptions}>
            <MenuItem value="code">Código</MenuItem>
            <MenuItem value="family">Familia</MenuItem>
            <MenuItem value="pseudonym">Nombre Común</MenuItem>
            <MenuItem value="specie">Nombre Científico</MenuItem>
          </Select>
        </FormControl>

        {initialize && (
          <SearchMain
            searchType={basicList.type}
            filterList1={basicList.filterList1}
            width={WINDOWWIDTH ? '100%' : `calc(100% - ${WIDTHF1}px)`}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Botton
            variant={wWSmall ? 'outlined' : 'text'}
            text={
              wWSmall ? (
                <ManageSearch sx={{ fontSize: 'large', mx: 1 }} />
              ) : (
                'Búsqueda Avanzada'
              )
            }
            onClick={handleAdvancedSearch}
            startIcon={!wWSmall ? <ManageSearch /> : null}
            styleButton={styleAdvancedSearchButton}
            size="small"
          />
        </Box>
        <Box sx={{ ml: 1 }}>
          <Botton
            text="Filtrar"
            onClick={handleFilters}
            startIcon={<FilterAlt />}
            styleButton={styleDefault}
            size="small"
            disabled={!Boolean(basicList.filterList1.length) || enableFilterButton}
          />
        </Box>
      </Box>
    </>
  )
}
export default SimpleSearch
